module.exports = __webpack_public_path__ + "static/img/banner1.4a62f52f.jpg";